import adminGetter from './adminGetter'
import userGetter from './userGetter'

export default {
  ...adminGetter,
  ...userGetter,
}
